import React from 'react';

function VisibilityCaret({ onClick, isHidden }) {
  const iconClass = isHidden ? 'fa-angle-down' : 'fa-angle-up';

  return (    
    <a onClick={onClick} className="icon is-small is-pulled-right"><i className={`fas ${iconClass}`}></i></a>
  );
}

export default VisibilityCaret;